import React from "react";

const RenderSelfAssessment = ({ selfAssessment }) => {
    let display = "N/A";

    switch (selfAssessment?.status) {
        case "open":
            display = "To be completed";
            break;

        case "closed":
            display = "Completed";
            break;

        default:
            break;
    }

    return <span>{display}</span>;
};

export default RenderSelfAssessment;
